import { createActionGroup, emptyProps, props } from '@ngrx/store';

import * as fromGenerated from '../../_generated';

/** R1 (i)'s row, with the `isDefaultChat` flag of the designation route. */
export type AdminManagedSkillRow = fromGenerated.AdminManagedSkillView;

export type AdminManagedSkillsSortColumn = 'name' | 'teammates' | 'shares';
export type AdminManagedSkillsSortDirection = 'asc' | 'desc';

/**
 * The Expertises list's reads, its delete and the default chat designation. Sort and filter are
 * client-side over the full list `Load Managed Skills` fetches;
 * `selectFilteredSortedManagedSkills` applies them.
 */
export const AdminManagedSkillsActions = createActionGroup({
  source: 'AdminManagedSkills',
  events: {
    'Load Managed Skills': emptyProps(),
    'Load Managed Skills Success': props<{
      skills: AdminManagedSkillRow[];
    }>(),
    'Load Managed Skills Failure': props<{ error: string }>(),

    'Set Sort': props<{
      column: AdminManagedSkillsSortColumn | null;
      direction: AdminManagedSkillsSortDirection;
    }>(),
    'Set Filter': props<{ filter: string }>(),

    // Lazy per-row expand payload for the teammates / direct-shares count cells.
    'Load Dropdown Payload': props<{ skillId: string }>(),
    // `generation` is the list load the request started under; the reducer
    // drops a response from an earlier one (a reload started meanwhile; the
    // builder triggers one on every close).
    'Load Dropdown Payload Success': props<{
      skillId: string;
      payload: fromGenerated.ManagedSkillDropdownPayloadView;
      generation: number;
    }>(),
    'Load Dropdown Payload Failure': props<{
      skillId: string;
      error: string;
      generation: number;
    }>(),

    // Supprimer. `assistant` is the skill's store entity, captured when the
    // confirm opens: the effect dispatches it onward as
    // the owner flow's `AssistantActions.deleteAssistantSuccess`, so every
    // listener of an owner delete (the store removal, the chats removal,
    // `skill_deleted` and the success toast) also runs for this one.
    'Delete Managed Skill': props<{
      skillId: string;
      assistant: fromGenerated.AssistantView;
    }>(),
    'Delete Managed Skill Success': props<{ skillId: string }>(),
    'Delete Managed Skill Failure': props<{
      skillId: string;
      error: string;
      errorName: string | null;
    }>(),

    // "Chat par défaut": the target becomes the one default chat. The success
    // carries the target's row only; the reducer clears the flag elsewhere.
    'Set Default Chat': props<{ skillId: string }>(),
    'Set Default Chat Success': props<{ skill: AdminManagedSkillRow }>(),
    'Set Default Chat Failure': props<{
      skillId: string;
      error: string;
      conflict: boolean;
    }>(),
  },
});
